import React, { useState, useEffect } from "react";
import { Row, Col, Card, ProgressBar, Pagination, Alert, Spinner } from "react-bootstrap";
import HelperFunction from '../util/helper'
import { SYSTEM_DEFAULTS } from '../util/constants'
import { useSharedData } from "../context/sharedDataContext";
import APIFunction from "../util/api";
import SavingsPlanModal from "./savingsPlanModal";

export default function SavingsPlan({ preview = false }){
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [savingPlans, setSavingPlans] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [showPlanModal, setShowPlanModal] = useState(false);

    const { summery, loading } = useSharedData();

    const fetchSavingsPlan = async (page) => {
        try {
          setIsLoading(true);
          setError('');
    
          const response = await APIFunction.getUserSavingsPlan(page)
        
          // API should return: { data: [], pagination: number }
          if(response.pagination?.totalPages) {
            setTotalPages(response.pagination.totalPages)
          }
          setSavingPlans(response.data);
        } catch (err) {
          setError(err.message);
        } finally {
          setIsLoading(false);
        }
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    useEffect(() => {
        fetchSavingsPlan(currentPage);
    }, [currentPage]);

    if(isLoading || loading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }
    if(error) {
        return <Alert variant="danger">{error}</Alert>
    }

    const { total } = HelperFunction.totalPackages(summery)

    return (
        <>
            <Card className="saving-plans-card mb-4">
                <Card.Body>
                    <div className="card-header-custom">
                        <h5><i className="bi bi-boxes"></i> Saving Plans</h5>
                        <button className="add-plan-btn" onClick={() => setShowPlanModal(true)}>+ Add Plan</button>
                    </div>
                    <div className="total-savings">
                        <span className="savings-label">Total Savings</span>
                        <h3>{HelperFunction.formatCurrency(total)}</h3>
                    </div>
                    <div className="savings-list">
                        {savingPlans.map((plan, index) => (
                            <div key={index} className="savings-item">
                            <div className="savings-header">
                                <span className="savings-name">{plan.name}</span>
                                <button className="savings-menu">⋯</button>
                            </div>
                            <ProgressBar 
                                now={HelperFunction.getPercent(parseFloat(plan.total), parseFloat(plan.target))} 
                                className="savings-progress"
                                variant={HelperFunction.getPercent(parseFloat(plan.total), parseFloat(plan.target)) > 50 ? "success" : "warning"}
                            />
                            <div className="savings-info">
                                <span>{HelperFunction.formatCurrency(parseFloat(plan.total))} - <span className="percent">{HelperFunction.getPercent(parseFloat(plan.total), parseFloat(plan.target))}%</span></span>
                                <span className="savings-target">Target: {HelperFunction.formatCurrency(parseFloat(plan.target))}</span>
                            </div>
                            </div>
                        ))}
                        {/* Pagination only if preview === true */}
                        {!preview && (
                            <div className="d-flex justify-content-center">
                                <Pagination>
                                    <Pagination.Prev
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    />
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <Pagination.Item
                                            key={index + 1}
                                            active={index + 1 === currentPage}
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                        {index + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    />
                                </Pagination>
                            </div>)
                        }
                    </div>
                </Card.Body>
            </Card>
            <SavingsPlanModal show={showPlanModal} onClose={() => setShowPlanModal(false)} />
        </>
    )
}